import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar} from '@angular/material/snack-bar';
import { Md5 } from 'ts-md5/dist/md5';

import { ApiService, DialogsService } from '../../custom-material/Services/';
import { StatsheetModel, BuildingModel, UserModel } from '../../main/Models';
import { LinechartComponent } from '../linechart/linechart.component';
import { BuildingChooseComponent } from "../../main/Components/building-choose/building-choose.component";
import { globalData, selectionObserver } from 'src/app/main/Models/global.model';


@Component({
  selector: 'statistics-stats',
  templateUrl: './t_stats.component.html',
  styleUrls: ['./stats.component.less']
})
export class StatsComponent implements OnInit, selectionObserver {


  buildings: Array<BuildingModel> = [];

  parentStatCats: Array<string> = [];
  childStatCats: Array<any> = [];
  showChild:Array<boolean> = [];

  monthes: Array<string> = ['JAN','FEV','MARS','AVR','MAI','JUIN','JUIL','AOUT','SEPT','OCT','NOV','DEC'];

  buildingSheets: Array<any> = []; //StatSheets sorted by [buildingId][year]=sheet

  data:Array<any> = []; //matrix to display in the table
  emptyData:string = ''; //model matrix (every value = 0)

  currentBuilding:number; //active building id
  currentYear:number; //active year
  get currentSheet():StatsheetModel
  {
    if(this.currentBuilding==undefined
    || this.currentYear==undefined) return null;

    return this.buildingSheets[this.currentBuilding][this.currentYear];
  }
  get yearBar()
  {
    return this.buildingSheets[this.currentBuilding]
      .filter((sheet)=>sheet!=undefined)
      .map(sheet=>sheet.year)
      .reverse();
  }


  //@ViewChild('statsBchooser') buildingChooser: BuildingChooseComponent;

  @ViewChild('linechart') chart: LinechartComponent;
  showInChart:Array<number> = [];
  chartData:Array<any> = [];


  @Input('fullPage') fullPage:boolean = true;
  @Input('openedBuildingIdD') openedBuildingIdD; //if !fullPage


  get autoSelect()
  {
    if(this.route.snapshot.params['building']!=undefined) {
      return +this.route.snapshot.params['building'];
    } else {
      return 'all';
    }
  }

  constructor(private apiService: ApiService,
              private router: Router,
              private route: ActivatedRoute,
              private gd: globalData,
              private snackBar: MatSnackBar) { 
                this.gd.headerTitle = 'Statistiques mensuelles';
                this.gd.headerIcon = 'show_chart';
                this.gd.toolService = this;
                /*this.gd.toollist = [{
                    "Type": "Button",
                    "Label": "Enregistrer",
                    "Color": "accent",
                    "Icon": "save",
                    "Method": "save",
                }];*/
              }

  ngOnInit() {
    this.gd.subscribe(this);
    this.getStatcat().then(()=>{
      if(!this.fullPage && this.openedBuildingIdD!=undefined) {
        this.gd.selectedBuildingsList = [this.openedBuildingIdD];
      }
      if(this.fullPage) {
        this.gd.toollist = [];
        this.gd.showChooser = true;
      }
      this.buildingsSelectionChanged(false);
    });
  }


  //before destroy ?
  ngOnDestroy()
  {
    this.save();
  }

  //load categories
  getStatcat()
  {
    return new Promise((resolve, reject)=>{
      //setTimeout(()=>{ this.snackBar.open('chargement en cours'); }, 0);
      this.apiService.getAllFromServer('statcat')
      .then((elements:Array<any>) => {
        let tmpData = [];
        for (let i in elements) {
          let el=elements[i];

          if(el.parent==0) {
            this.parentStatCats[el.id] = el.name;
            this.showChild[el.id] = false;
          } else {
            if(!this.childStatCats[el.parent]) {
              this.childStatCats[el.parent] = [];
              tmpData[el.id] = [];
            }
            this.childStatCats[el.parent][el.id] = el.name;
            tmpData[el.id] = [0,0,0,0,0,0,0,0,0,0,0,0];
            
          }
        }

        this.emptyData = JSON.stringify(tmpData);
        this.data = tmpData;
        //setTimeout(()=>{ this.snackBar.dismiss(); }, 100);
        resolve(true);
        });
      });
  }

  //Show/hide sub-categories of parent p
  toggleChild(p)
  {
    this.showChild[p] = !this.showChild[p];
  }

  

  //give the total of sub-categories of parent p for month m
  totalMonth(p, m)
  {
    let total = 0;
    for(let c in this.childStatCats[p]) {
        let plus = parseInt(this.data[c][m]);
        total += isNaN(plus) ? 0 : plus;
    }
    return total;
  }

  //give the year total of a sub-category
  totalYear(c)
  {
    let total = 0;
    for(let m in this.monthes) {
        let plus = parseInt(this.data[c][m]);
        total += isNaN(plus) ? 0 : plus;
    }
    return total;
  }

  //give the year total of a parent category
  totalCat(p)
  {
    let total = 0;
    for(let c in this.childStatCats[p]) {
      for(let m in this.monthes) {
        let plus = parseInt(this.data[c][m]);
        total += isNaN(plus) ? 0 : plus;
      }
    }
    return total;
  }

  //set focus with arrow keys
  changeFocus(event)
  {
    let key = event.code;
    let itemId = event.explicitOriginalTarget.attributes.id.nodeValue;
    let itemSplit = itemId.split('-');
    let cat = itemSplit[0];
    let month = itemSplit[1];

    switch(key) {
      case 'ArrowUp':
        cat--; break;
      case 'ArrowDown':
      case 'Enter':
        cat++; break;
      case 'ArrowLeft':
        month--; break;
      case 'ArrowRight':
        month++; break;
    }

    let newItem = window.document.getElementById(cat+'-'+month);
    if(newItem!=undefined) {
      newItem.focus()
    }
  }

  //Check an entered value is a number, else set it to 0 (on blur)
  onBlur(event)
  {
    let value = parseInt(event.explicitOriginalTarget.value);
    if(isNaN(value)) value = 0;
    event.explicitOriginalTarget.value = value;  // Math.abs(value);

    //this.recalcChartData(); //chart is over inputs, so you can't change numbers and see changes on chart
  }


  /**
  * load a Statsheet in the table
  */
  load(year:number, buildingID:number=null)
  {
    if(this.currentSheet && this.currentBuilding!=0) this.record();
    if(buildingID) this.currentBuilding = buildingID;
    this.currentYear = year;

    if(this.currentSheet!=null) {
      this.data = JSON.parse(this.currentSheet.data);
      ////this.feedChart(this.currentSheet);
      this.chart.setTitle(this.currentSheet.year);
      } else {
    }
    this.recalcChartData();
  }

  /**
  * load a set of StatSheets
  * TODO : gérer la navigation entre les années
  */
  loadMulti(buildingIDs)
  {
    this.data = JSON.parse(this.emptyData);
    for (var b = buildingIDs.length - 1; b >= 0; b--) {
      let bID = buildingIDs[b];
      let bData = JSON.parse(this.buildingSheets[bID][this.currentYear].data);
      for (let c = bData.length - 1; c >= 0; c--) {
        if(bData[c]==null) continue;
        for(let m = bData[c].length - 1; m>=0; m--) {
            this.data[c][m] = parseInt(this.data[c][m]) +  parseInt(bData[c][m]);
        }
      }
    }

    let ssm = new StatsheetModel({
      id: 0,
      building: new BuildingModel({id: 0}),
      data: this.data
    });
    this.recordSheet(ssm);
    this.currentBuilding = 0;
    //this.feedChart(this.currentSheet);
    this.chart.setTitle(this.currentSheet.year);
    this.recalcChartData();
  }

  /**
  * Record the current table ine the Statsheet
  */
  record()
  {
    if(this.currentSheet!=null && this.currentBuilding!=0) 
      this.currentSheet.data = JSON.stringify(this.data);
  }

  /**
  * Save all sheets in buildingSheets via API
  */
  save()
  {
    this.record();
    for(let bID in this.buildingSheets) {
      if(bID=='0') continue;
      for(let year in this.buildingSheets[bID]) {
        
        if(!this.buildingSheets[bID][year].id) {
        this.apiService.SaveToServer('statsheet', this.buildingSheets[bID][year].export())
            .then(s => s.subscribe((response:any) => {
              this.buildingSheets[bID][year] = new StatsheetModel(response);
            }));
        } else {
        this.apiService.UpdateToServer('statsheet', this.buildingSheets[bID][year].export())
            .then(s => s.subscribe((response:any) => {
              this.buildingSheets[bID][year] = new StatsheetModel(response);
            }));
        }
      }
    }
  }

  /**
  * manage buildingChooser.changeTriggered
  */
  buildingsSelectionChanged(save=true)
  {
    if(save) this.save();
    let statsToLoad = [];
    for (var i = this.gd.selectedBuildingsList.length - 1; i >= 0; i--) {
      let buildingID = this.gd.selectedBuildingsList[i];
      if(!this.buildingSheets[buildingID]) statsToLoad.push(buildingID);
    }
    this.getData(statsToLoad)
      .then(()=>{
        if(this.gd.selectedBuildingsList.length==1) {
          //charger fiche d'un bâtiment
          let buildingID = this.gd.selectedBuildingsList[0];
          this.completeBuildings([buildingID]);
            
          if(!this.currentYear
          || this.buildingSheets[buildingID][this.currentYear]==undefined) 
            this.currentYear =  new Date().getFullYear();
            
          this.load(this.currentYear, this.gd.selectedBuildingsList[0]);
            
        } else {
          //gérer plusieurs bâtiments
          this.completeBuildings(this.gd.selectedBuildingsList);
          this.currentYear =  new Date().getFullYear();
          this.loadMulti(this.gd.selectedBuildingsList);
        }
      });
  }

  /**
  * get Statsheets of called buildings via API
  */
  getData(buildingIDs:Array<number>)
  {
    return new Promise((resolve, reject)=>{
      if(buildingIDs.length==0) {
        resolve(true);
        return;
      }

      //setTimeout(()=>{ this.snackBar.open('chargement en cours'); }, 0);
      let StatsheetMemberof:any = {
    		building: buildingIDs
    	};
    	let StatsheetParams = this.apiService.createParams(StatsheetMemberof, 'in',
        true, 'year', 'desc');
    	
      this.apiService.getFromServer('statsheet', StatsheetParams)
    		.then(s=>s.subscribe((response:any)=>{
          
          for(let s in response._embedded.statsheet) {
            let sheet = new StatsheetModel(response._embedded.statsheet[s]);
            this.recordSheet(sheet);
            }
          
          this.completeBuildings(buildingIDs);
          

          //setTimeout(()=>{ this.snackBar.dismiss(); }, 100);
          resolve(true);
    		}));//getFromServer.then
    });//promise
  }

  /**
  * record a Statsheet in this.buildingSheets[bID][year]
  */
  recordSheet(sheet:StatsheetModel)
  {
    let bID = sheet.building.id;
    let year = sheet.year;

    if(this.buildingSheets[bID]==undefined)
      this.buildingSheets[bID] = [];
    this.buildingSheets[bID][year] = sheet;

    }

  /**
  * create current year sheet of a buildilngs if not existing
  */
  completeBuildings(bIDs:Array<number>)
  {
    let currentYear = new Date().getFullYear();
    bIDs.forEach((bID)=>{
      if(this.buildingSheets[bID]==undefined || this.buildingSheets[bID][currentYear]==undefined) {
        let building = this.gd.findBuildingById(bID);
        let sheet = new StatsheetModel({
          building: building,
          year: currentYear,
          data: this.emptyData
        });
        this.recordSheet(sheet);
      }
    });
  }

  toggleChart(id)
  {
    let index = this.showInChart.indexOf(id)
    if(index > -1) { //exists -> remove
      this.showInChart.splice(index, 1);
      window.document.getElementById('tglch-'+id).style.backgroundColor = '#c0c0c0';
      this.recalcChartData();
    } else { //  does not exist -> add
      this.showInChart.push(id);
      this.recalcChartData();
      window.document.getElementById('tglch-'+id).style.backgroundColor = 
        this.chartData[id].color;
    }
  }
  removeAllChart()
  {
    this.showInChart.forEach((id)=>{
      window.document.getElementById('tglch-'+id).style.backgroundColor = '#c0c0c0';
    });
    this.showInChart = [];
    this.chartData = [];
    this.chart.removeAllChart();
  }

  recalcChartData()
  {
    let chartData = [];
    let BreakException = {};

    this.data.forEach((line, index)=>{
      if(index==0) return; //do not exists, because index is id of statcat, and begin with 1

      if(this.showInChart.indexOf(index)==-1) return; //not activated

      if(line == null) { //it is a parent category
        chartData[index] = {
          label: this.parentStatCats[index],
          data: [],
          color: '#'+Md5.hashStr(this.parentStatCats[index]).slice(0,6)
        };
        for(let m in this.monthes) {
          chartData[index].data[m] = this.totalMonth(index, m);
        }

      } else {  //it is a sub-category
        
        try {
          this.childStatCats.forEach((subcats:Array<any>, parentInd)=>{
            if(subcats[index] != undefined) {
              chartData[index] = {
                label: subcats[index],
                data: line,
                color: '#'+Md5.hashStr(subcats[index]).slice(0,6),
                type: 'line'
              }
              throw BreakException;
            }
          });
        } catch (e) {
          if (e !== BreakException) throw e;
        }
      }
    });
    
    this.chartData = chartData;
    this.chart.setChartData(chartData);
  }

}
